import React, { useEffect, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AlertCircle, Utensils, Loader2 } from 'lucide-react';
import { customerAuth } from '../../services/customerService';
import { useT } from '../../context/LanguageContext';

/** CustomerLogin: the table-QR entry point, now a pure redirector into the account flow. */
export default function CustomerLogin() {
  const { t } = useT();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const token = params.get('qr') || params.get('token') || '';

  const isCustomerAuthed = customerAuth.isLoggedIn();

  useEffect(() => {
    if (!token) return;
    const menuUrl = `/customer/menu?token=${encodeURIComponent(token)}`;
    if (isCustomerAuthed) {
      navigate(menuUrl, { replace: true });
    } else {
      navigate(`/customer/account-login?next=${encodeURIComponent(menuUrl)}`, {
        replace: true,
      });
    }
  }, [isCustomerAuthed, token, navigate]);

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-amber-50 via-white to-orange-50 text-gray-900 flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md text-center">
        <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-amber-100 shadow-sm mb-4">
          <Utensils className="h-7 w-7 text-amber-700" />
        </div>
        {token ? (
          <div className="flex flex-col items-center gap-3 text-gray-500">
            <Loader2 className="h-6 w-6 animate-spin text-amber-600" />
            <p className="text-sm">{t('guest.login.opening')}</p>
          </div>
        ) : (
          <div className="mx-auto max-w-sm rounded-2xl bg-white shadow-lg border border-gray-100 p-6">
            <div className="flex items-start gap-3 rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-700 text-left">
              <AlertCircle className="h-5 w-5 mt-0.5 text-red-500 flex-shrink-0" />
              <div>{t('guest.login.qrOnly')}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
